<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card-text>
          <v-row justify="end">
            <v-col cols="12" md="6">
              <v-col cols="12">
                <v-tooltip bottom color="blue" max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Buscar"
                      v-model="search"
                      dense
                      hide-details
                      filled
                      single-line
                      append-icon="mdi-magnify"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <span>Busca alumno por matrícula o nombre</span>
                </v-tooltip>
              </v-col>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers2"
            :items="alumnos2"
            :search="search"
            dense
          >
            <template v-slot:item.opciones="{ item }">
              <v-tooltip bottom color="blue" max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    color="orange" 
                    dark 
                    x-small
                    @click="$emit('addDialogCambio',item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Seleccionar este alumno</span>
              </v-tooltip>

            </template>
          </v-data-table>
        </v-card-text>
	    </v-col>
	  </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  
  import axios from 'axios';
	var moment = require('moment');
  moment.locale();
	import XLSX from 'xlsx'
  import { mapGetters } from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {

    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel ],

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      search: '',
      
      headers2: [
        { text: 'Matricula',   value: 'matricula' },
        { text: 'Nombre',      value: 'alumno' },
        { text: 'Opciones',    value: 'opciones' },
      ],

      tipociclo:'',

      alumnos2:[],

    }),


    async created () {
      console.clear()
      // Primero necesitamos consultar el tipo de usuario y de donde viene
      await this.getAlumnosxEscuela2( )
    },

    methods: {
      getAlumnosxEscuela2 () {
      	if([1,2,3,4,5,6,17,19,21,22,23,24,25,26].includes( this.getdatosUsuarioERPERP.id_plantel ) ){
          this.tipociclo = `grupo NOT LIKE '%FE%'`
        }else{ this.tipociclo = `grupo LIKE '%FE%'` }
        
        // Vaciamos el arreglo de los grupos
        this.alumnos2 = []
        // Activamos el loader
        this.cargar = true
        const payload =  { tipociclo: this.tipociclo }
        return this.$http.post('cambios.alumnos.grupos',payload).then(response=>{
          // Llenamos el arreglo de alumnos
          this.alumnos2 = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },
    },

    computed:{
      ...mapGetters ('login',['getdatosUsuarioERPERP']),
    }
  }
</script>
